import { useQueryClient } from "@tanstack/vue-query";
import type {
  DashboardCacheVersions,
  DashboardWidgetName,
} from "@/core/interfaces/Dashboard";
import {
  applyDashboardVersionChanges,
  invalidateAllDashboardWidgets,
  invalidateDashboardWidget,
  invalidateDashboardWidgets,
} from "@/core/helpers/apply-dashboard-versions";

/**
 * Selectively invalidate dashboard queries based on cache version deltas.
 */
export function useDashboardInvalidation() {
  // Keep queryClient subscription aligned with Vue Query plugin lifecycle.
  useQueryClient();

  function invalidateWidget(widget: DashboardWidgetName): void {
    invalidateDashboardWidget(widget);
  }

  function invalidateWidgets(widgets: DashboardWidgetName[]): void {
    invalidateDashboardWidgets(widgets);
  }

  function invalidateAllDashboard(): void {
    invalidateAllDashboardWidgets();
  }

  function applyVersionChanges(
    previous: DashboardCacheVersions,
    next: DashboardCacheVersions
  ): void {
    applyDashboardVersionChanges(previous, next);
  }

  return {
    invalidateWidget,
    invalidateWidgets,
    invalidateAllDashboard,
    applyVersionChanges,
  };
}
